// extracted by mini-css-extract-plugin
export default {"isOpen":"h1eAGpWNDI"};